<template>
  <div class="frame-wrapper">
    <iframe
      v-if="url && !$apollo.loading"
      :style="{ width: '100%', height: '100%'}"
      :src="url"
    />
  </div>
</template>

<script>
import generatedUrlsMixin from '@/mixins/generated-urls'

export default {
  name: 'ViewWebsite',
  mixins: [generatedUrlsMixin],
  async beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$nextTick(async () => {
        let link = await vm.getWebsitePreviewLink()
        vm.url = link
      })
    })
  },
  data () {
    return {
      url: null
    }
  }
}
</script>

<style lang="scss">

  .frame-wrapper {
    margin: -15px -20px -20px -20px;
    height: calc(100vh - 102px);
  }
</style>
